import { Link } from "react-router-dom";
import useBreadcrumbs from "use-react-router-breadcrumbs";

const Breadcrumbs = () => {
  const breadcrumbs = useBreadcrumbs(); // auto from URL

  return (
    <nav aria-label="breadcrumb">
      <ol
        className="breadcrumb mb-0 d-flex"
        style={{ "--bs-breadcrumb-divider": "'>'" } as React.CSSProperties}
      >
        {breadcrumbs.map(({ match, breadcrumb }, index) => {
          const isLast = index === breadcrumbs.length - 1;
          const label =
            typeof breadcrumb === "string"
              ? breadcrumb.replace("/", "").replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
              : breadcrumb;

          return (
            <li
              key={match.pathname}
              className={`breadcrumb-item ${isLast ? "active" : ""}`}
              aria-current={isLast ? "page" : undefined}
            >
              {!isLast ? <Link to={match.pathname}>{label}</Link> : label}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;